import React from "react";
import Button from "storybookComponents/Button";
import { CopyIconPreview } from "icons";
import Icon from "storybookComponents/Icon"
import "./index.css"


const DirectLink = ({ enrollUrl }) => {
  const [copyText, setCopyText] = React.useState("Copy Direct Link");
  const [iconStroke, setIconStroke] = React.useState('#333');
  const copyTextToClipboard = () => {
    navigator.clipboard.writeText(enrollUrl).then(function () {
      setCopyText("Direct Link Copied");
      setTimeout(() => {
        setCopyText("Copy Direct Link");
      }, 2000)
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }



  return <div id="direct-link">
    <div className="mainContainer">
      <div className="label-style">Here's the link for residents to enrol to this campaign</div>
      <div className="link-container" onMouseEnter={() => setIconStroke('#26BBED')}
        onMouseLeave={() => setIconStroke('#333')}>
        <div className="icon">
          <CopyIconPreview stroke={iconStroke} />
        </div>

        <a className="link" target="_blank" href={enrollUrl}>{enrollUrl}</a>
      </div>
      <Button variant="secondary" size="md"
        className={`${copyText === "Direct Link Copied" ? "button-copied" : "button-css"}`}
        onClick={copyTextToClipboard} ><div className="flex-box">{copyText === "Direct Link Copied" && <Icon className="icon" type="icon-check-single" size="sm" />}{copyText}</div></Button>
    </div>
  </div>
}

export default DirectLink